import BaseApiServiceV2 from "./BaseApiServiceV2";

class BlogsService extends BaseApiServiceV2 {
	/**
	 * @param {String} id
	 * @returns Promise<Object>
	 * @memberof SearchService
	 */

	getBlogsByCategory(category: string, country: string) {
		return this.apiGet(
			`/blog-post/blogs-by-blog-category/?region=${country}&page=1&perPage=15&blogCategory=${category}`,
		);
	}

	getAreaBlogs(id: string) {
		return this.apiGet(`/blog-post/area-profile/${id}`);
	}

	getSpaceTypeBlogs(country: string) {
		return this.apiGet(`/blog-post/blogs?region=${country}`);
	}

	getWorkspaceBlogs(id: string, region: string) {
		return this.apiGet(`/blog-post/${region}/workspace/${id}`);
	}

	getBlogData(region: string, perPage = 5) {
		return this.apiGet(
			`/blog-post/all-post-types?region=${region}&page=1&perPage=${perPage}`,
		);
	}

	getBlogsWithRegion(region: string, perPage?: number) {
		return this.apiGet(
			`/blog-post/paginated-blogs/?page=1&perPage=${perPage || 10}&region=${region}&postType=latest-news`,
		);
	}
	getBlogBySlug(slug: string) {
		return this.apiGet(`/blog-post/blogs-by-slug?slug=${slug}`);
	}
	fetchBlogs(
		page: number,
		perPage: number,
		region: string = "Australia",
		postType: string,
	) {
		return this.apiGet(
			`/blog-post/paginated-blogs/?page=${page}&perPage=${perPage}&region=${region}&postType=${postType}`,
		);
	}
	fetchBlogMedia(
		region: string,
		mediaType?: string = "",
		page?: number = 1,
		perPage?: number = 10,
		searchText?: string = "",
	) {
		return this.apiGet(
			`/mediapost/:${region}?mediaType=${mediaType}&page=${page}&perPage=${perPage}&searchText=${searchText}`,
		);
	}
	fetchBlogsByCategories(page = 1, perPage = 5, region: string, categories = '', blogSubCategory = '', searchText = '', postType = '', author = '') {
		return this.apiGet(
			`/blog-post/blogs-by-blog-category/?region=${region}&page=${page}&perPage=${perPage}&blogCategory=${categories}&blogSubCategory=${blogSubCategory}&searchText=${searchText}&postType=${postType}&authorName=${author}`,
		);
	}
	fetchNewsBlogs(perPage = 10, region: string) {
		return this.apiGet(`/blog-post/category/?perPage=${perPage}&region=${region}`);
	}

}
export default new BlogsService();
